import { UserMetadata } from '@x/model/user.model';
import { Company } from '@x/model/company.model';

export interface BaseUser {
  readonly id: number;
  readonly username: string;
  readonly email: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly phone: string;
  readonly enabled: boolean;
  readonly verified: boolean;
  readonly created: string;
  readonly updated: string;
  readonly acceptAgreementUpdated: string;
  readonly acceptPrivacyUpdated: string;
  readonly acceptTermsUpdated: string;
  readonly metadata?: UserMetadata;
  readonly companyAtecoCode: string;
  readonly companyAtecoDescription: string;
  readonly companyId: number;
  readonly companyName: string;
  readonly companyTaxCode: string;
  readonly companyVatCode: string;
  readonly image: string;
  // set by the backoffice: the user must change the password before using the platform
  readonly forcePasswordChange?: boolean;
}

export interface User extends BaseUser {
  readonly role: Role;
  readonly company: Company;
  readonly taxCode?: string;
  readonly vatCode?: string;
}

export enum Role {
  USER = 'USER',
  ACCOUNTANT = 'ACCOUNTANT',
  BANK = 'BANK',
}

export const RolesLabel = new Map<Role, string>([
  [Role.USER, 'UTENTE'],
  [Role.ACCOUNTANT, 'COMMERCIALISTA'],
  [Role.BANK, 'BANCA'],
]);

export interface UserRole {
  readonly key: Role;
  readonly value: string;
}
